/* 兑换接口 */
import http from '@/utils/http'

const api = {
  redeem: '/api/redeem'
}

/**
 * 兑换
 * @export
 * @returns
 */
export function sendCdkey(token, code) {
  return http.get(api.redeem, { token: token, code: code })
}
